export default __webpack_public_path__ + "static/why-ml-3-ca2d433fa5b2cee3da145c7dc4f364f0.jpg";